import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
import ExperiencePrices from './ExperiencePrices';
const Prices = t0 => {
    const $ = _c(8);
    const { type, prices, className } = t0;
    const translate = useTranslate();
    const t1 = type;
    const t2 = prices;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = <ExperiencePrices type={t1} prices={t2}/>;
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    }
    else {
        t3 = $[2];
    }
    const pricesContent = t3;
    const computedClassName = `flex flex-col ${className}`;
    const title = `${capitalize(translate("practical.prices.label"))}`;
    let t4;
    if ($[3] !== computedClassName || $[4] !== prices || $[5] !== pricesContent || $[6] !== title) {
        t4 = prices && pricesContent && <div className={computedClassName}><h2 className="text-title mb-5">{title}</h2>{pricesContent}</div>;
        $[3] = computedClassName;
        $[4] = prices;
        $[5] = pricesContent;
        $[6] = title;
        $[7] = t4;
    }
    else {
        t4 = $[7];
    }
    return t4;
};
export default Prices;
